import {ACCESS_TOKEN, V1_API_URL_PREFIX} from '../Constants';
import {request} from "./ApiUtils";

export function audit() {
    return request({
        url: V1_API_URL_PREFIX + "/audit",
        method: 'GET'
    });
}

export function auditPlan() {
    return request({
        url: V1_API_URL_PREFIX + "/audit-plan",
        method: 'GET'
    });
}

export function auditPlanRevision() {
    return request({
        url: V1_API_URL_PREFIX + "/audit-plan/latestRevision",
        method: 'GET'
    });
}

export function saveOrUpdateAudit(record) {
    return request({
        url: V1_API_URL_PREFIX + "/audit/update",
        method: 'POST',
        body: JSON.stringify(record)
    });
}

export function saveOrUpdateAuditPlan(record) {
    return request({
        url: V1_API_URL_PREFIX + "/audit-plan/update",
        method: 'POST',
        body: JSON.stringify(record)
    });
}

export function deleteAuditPlan(auditPlan) {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    const defaults = {headers: headers};
    let options = Object.assign({}, defaults, {
        url: V1_API_URL_PREFIX + "/audit-plan/delete",
        method: 'DELETE',
        body: JSON.stringify(auditPlan)
    });

    return fetch(options.url, options)
        .then(response => {
                if (response.status !== 204) {
                    return Promise.reject();
                }
                return Promise.resolve();
            }
        );
}

export function addAuditPlanRevision(record) {
    return request({
        url: V1_API_URL_PREFIX + "/audit-plan/add/revision",
        method: 'POST',
        body: JSON.stringify(record)
    });
}
